<template>
  <SimpleNoteCreateConceptPaymentPlanMode
    :show="show"
    :payment-id="prefillPaymentId"
    :existing-concepts="existingConcepts"
    :selected-receiver="selectedReceiver"
    :currency="currency"
    @close="$emit('close')"
    @submit="$emit('submit', $event)"
  />
</template>

<script>
import SimpleNoteCreateConceptPaymentPlanMode from '@/components/simple-notes/create/SimpleNoteCreateConceptPaymentPlanMode.vue';

export default {
  name: 'SimpleNoteCreateConceptModal',
  components: {
    SimpleNoteCreateConceptPaymentPlanMode,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'create',
    },
    initialData: {
      type: Object,
      default: null,
    },
    existingConcepts: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: 'MXN',
    },
    prefillPaymentId: {
      type: Number,
      default: 0,
    },
    selectedReceiver: {
      type: Object,
      default: null,
    },
  },
  emits: ['close', 'submit'],
};
</script>
